<template>
  <div
    id="app"
    onselectstart="return false"
    onpaste="return false;"
    onCopy="return false"
    onCut="return false"
    onDrag="return false"
    onDrop="return false"
  >
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  data: () => ({
    user: [],
    language: [],
    alert: { color: "", message: "" },
    count: 0,
    terms: null,
    ip: null,
    country: null,
  }),

  created() {
    this.user = JSON.parse(
      localStorage.getItem(process.env.VUE_APP_PARSE_LOCAL_STORAGE)
    );
    this.language = localStorage.getItem("OTT/Language/Guest");
    if (this.user != null) {
      this.$store.commit("userLocalSotrage", this.user);
    }
    if (this.language != null && this.language != undefined) {
      this.$store.commit("CHANGE_COUNTRY", this.language);
    } else {
      this.getIP();
    }

    this.$store.dispatch("FETCH_ADS_BANNERS");
    this.$store.dispatch("FETCH_PLATFORMS");
    this.$store.dispatch("FETCH_CANT_WATCH_WATCHLIST");
    console.log("V13.0.0");
    document.addEventListener("AppleIDSignInOnSuccess", (data) => {
      this.loginApple(data);
    });
  },
  methods: {
    async getIP() {
      this.ip = await this.$http.get("https://icanhazip.com");
      this.country = await this.$http.get(
        `https://freegeoip.app/json/${this.ip.data}`
      );
      if (
        this.country.data.country_code == "AR" ||
        this.country.data.country_code == "IN"
      )
        this.$store.dispatch("SET_COUNTRY", "India");
      else this.$store.dispatch("SET_COUNTRY", "USA");
      this.$store.dispatch("FETCH_PLATFORMS");
    },

    async loginApple(data) {
      this.count++;
      if (this.count % 2 == 0) {
        let auth = data.detail.authorization.id_token;
        let user_id = [];
        try {
          user_id = JSON.parse(atob(auth.split(".")[1]));
        } catch (e) {
          user_id = null;
        }
        let authData = {
          authData: {
            id: user_id.sub,
            token: auth,
          },
        };
        let current = await this.$Parse.User.logInWith("apple", authData);
        if (!current.country) this.$store.dispatch("SET_COUNTRY", "USA");
        this.$store.commit("dataUser", current);
        let params = { name: user_id.email };
        this.$store.dispatch("SET_USERNAME", params);
        this.alert.color = "#94C659";
        this.alert.message = "Login Successful";
        this.$store.commit("editAlert", this.alert);
        this.$store.commit("DISABLED_MENU");
        this.$store.dispatch("FETCH_CANT_WATCH_WATCHLIST");
        console.log(current);
      }
    },
  },
};
</script>
<style>
#app {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffff;
  margin: 0px;
  padding: 0px;
  height: 100px;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
